import { Box, Stack, Typography } from "@mui/material";
import type { JSX, PropsWithChildren } from "react";
import DefaultIcon from "../../images/info_page_icon.svg";
import StyledPage from "./StyledPage";

interface Props {
  title: string;
  subtitle?: JSX.Element;
  Icon?: JSX.Element;
}

const InfoPage = ({ title, subtitle, Icon, children }: PropsWithChildren<Props>) => (
  <StyledPage sx={{ px: 2 }}>
    <Box sx={{ mt: -20, mb: 5 }}>{Icon || <img src={DefaultIcon} alt="logo" />}</Box>
    <Stack spacing={1} sx={{ alignItems: "center" }}>
      <Typography variant="h4">{title}</Typography>
      {subtitle}
    </Stack>
    <Box>{children}</Box>
  </StyledPage>
);

export default InfoPage;
